import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { F0Alert, F0Box } from '@factorialco/f0-react'
import { Spinner } from '@factorialco/f0-react/dist/experimental'
import { TrainingContentRootDocument } from 'generated/resources/graphql'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { useQuery } from 'modules/core/hooks/useQuery'
import i18n from 'modules/core/lib/i18n'
const ConsumerRoot = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { trainingId } = useParams()
  const {
    company: { id: companyId },
  } = useCurrentSession()
  const { data: trainingData, loading } = useQuery(TrainingContentRootDocument, {
    fetchPolicy: 'cache-first',
    variables: {
      trainingId: String(trainingId),
      companyId,
    },
    skip: !trainingId,
  })
  const isScormTraining = Boolean(trainingData?.trainings.training?.scormPackage)
  if (loading) {
    return (
      <F0Box padding="xl" width="full" alignItems="center">
        <Spinner />
      </F0Box>
    )
  }
  if (isScormTraining) {
    return (
      <F0Box padding="xl" width="full">
        <F0Alert
          variant="warning"
          title={i18n.t('trainings.scorm.content_consumer_not_available.title')}
          description={i18n.t('trainings.scorm.content_consumer_not_available.description')}
          action={{
            label: i18n.t('trainings.scorm.content_consumer_not_available.go_back'),
            onClick: () =>
              navigate(
                navigation.myTrainings.revamp.detailsRevamp.view.overview.fullPath({
                  trainingId: trainingId ?? '',
                })
              ),
          }}
        />
      </F0Box>
    )
  }
  return <Outlet />
}
export default ConsumerRoot
